export default __webpack_public_path__ + "static/media/scale-on-demand.dcb07600.gif";